import React, {useContext, useEffect} from "react";
import {RecordsManagementContext, ViewMangementContext} from "./StatesMangement/InitialiseContext";
import Loader from "./CommonComponents/Loader";
import ClientPortal from "./ClientPortal/ClientPortal";
import PageNotFound from "./CommonComponents/PageNotFound";
import SomethingWentWrong from "./CommonComponents/SomethingWentWrong";
import CompanyTermsAndConditions from "./CommonComponents/CompanyTermsAndConditions";
import ShowAddendum from "./CommonComponents/ShowAddendum";
import ShowEstimateAddendum from "./CommonComponents/ShowEstimateAddendum";
import {
    Elink,
    FetchClientInvoice2RecordsUrl,
    FetchIV2_PageDetails,
    FetchEstimateRecordsUrl,
    FetchInvoiceTypeUrl, CompanySubdomain, Subdomain, FetchStorageRecordsUrl, For
} from "./CommonComponents/Routes";
import axios from 'axios';
import ClientInvoice from "./ClientInvoice/ClientInvoice";
import ClientInvoiceTwo from "./ClientInvoice2/ClientInvoiceTwo";
import GoogleMap from "./CommonComponents/GoogleMap";
import StoragePortal from "./StoragePortal/StoragePortal";


const MainPage = () => { // This component render the diff pages.
    let PageView = useContext(ViewMangementContext)
    let RecordsController = useContext(RecordsManagementContext)
    let cookie = document.cookie
    cookie = cookie.split('employee_id=')[1]
    const FetchClientPortal = async () => {
        axios({
            method: 'post',
            url: FetchEstimateRecordsUrl,
            params: {estimate_key: Elink ,employee_key: cookie}
        }).then( async (response) => {
            const dynamicScript = document.createElement('script');
            dynamicScript.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${response.data.MapKey[0]}`)
            dynamicScript.id = "_d1"
            document.head.appendChild(dynamicScript);
            RecordsController.SetCP_PageDetails(response.data)
            PageView.Set('CLIENT_PORTAL')
            // After render the Client-portal, In backend fetch the records for Invoice according to Invoice-Type, to render Invoices in less time.
            if (response.data.InvoiceType === 'INVOICE_1') {
                await axios({method: 'post', url: FetchIV2_PageDetails, params: {estimate_key: Elink}})
                    .then((response) => {
                        RecordsController.SetIV1_PageDetails(response.data)
                    })
                PageView.setInvoiceType(response.data.InvoiceType)
            } else if (response.data.InvoiceType === 'INVOICE_2') {
                await axios({method: 'post', url: FetchClientInvoice2RecordsUrl, params: {estimate_key: Elink}})
                    .then((response) => {
                        RecordsController.SetIV2_PageDetails(response.data)
                    })
                PageView.setInvoiceType(response.data.InvoiceType)
            }
        }).catch(() => {
            PageView.Set('SOMETHING_WENT_WRONG')
        })
    }
    // fetch storage portal
    const FetchStoragePortal = async () => {
            axios({ method: 'post', url: FetchStorageRecordsUrl, params: { Storage_key: Elink, For: "storage", employee_key: cookie } })
            .then((response) => {
                RecordsController.SetSP_PageDetails(response.data)
                PageView.Set('STORAGE_PORTAL')
            }).catch(()=>{ PageView.Set('SOMETHING_WENT_WRONG') })
    }

    useEffect(async () => {
        if (Elink === null || Elink === '') { // If params 'elink' is not present in url then Page-Not-Found render in screen.
            PageView.Set('PAGE_NOT_FOUND')
        } else {
            await Subdomain();
            // setLiveChatScript(); // live chat call
            const gotoParam = new URLSearchParams(window.location.search.replace(/&amp;/ig, '&')).get('goto');
            if (gotoParam === 'invoice') {
                axios({method: 'post', url: FetchInvoiceTypeUrl, params: {estimate_key: Elink}}).then((response) => {
                    let result = response.data.InvoiceType === '' ?  FetchClientPortal() : response.data.InvoiceType
                    if (result === 'PAGE_NOT_FOUND') { PageView.Set(result) }
                    PageView.setInvoiceType(response.data.InvoiceType)
                    if (response.data.InvoiceType === 'INVOICE_1') {

                        FetchDigitalInvoiceRecord(PageView,RecordsController,'SetIV1_PageDetails',
                            'INVOICE_1',FetchIV2_PageDetails)

                    } else if (response.data.InvoiceType === 'INVOICE_2') {

                        FetchDigitalInvoiceRecord(PageView,RecordsController,'SetIV2_PageDetails',
                            'INVOICE_2',FetchClientInvoice2RecordsUrl)
                    }
                }).catch(() => {
                    PageView.Set('SOMETHING_WENT_WRONG')
                })
            } else if (gotoParam === 'storage') {
                FetchStoragePortal();
            } else { // If params 'goto' is not present for 'Invoice' but 'elink' is present then fetch the records for Client-Portal.
                FetchClientPortal()
            }
        }
    }, [])

// live chat implementation
    var domain = process.env.REACT_APP_DOMAIN.replace("'", "")
    let jQueryScript = document.createElement('script');
    let viaSms = new URLSearchParams(window.location.search).get('via')
    viaSms ? jQueryScript.setAttribute('src',domain+`/live_chat/ub7xgT18bQbWUDeatyCFwQ%3D%3D.js?key=${Elink}&via=${viaSms}&ts=${new Date().getTime()}&For=${For}`) :
        jQueryScript.setAttribute('src',domain+`/live_chat/ub7xgT18bQbWUDeatyCFwQ%3D%3D.js?key=${Elink}&ts=${new Date().getTime()}&For=${For}`)
    document.head.appendChild(jQueryScript);

    const getPage = () => {
        if (PageView.For === 'LOADING') {
            return (<Loader />);
        } else if (PageView.For === 'CLIENT_PORTAL') {
            return (<ClientPortal />);
        } else if (PageView.For === 'STORAGE_PORTAL') {
            return (<StoragePortal />);
        } else if (PageView.For === 'INVOICE_1') {
            return (<ClientInvoice />);
        } else if (PageView.For === 'INVOICE_2') {
            return (<ClientInvoiceTwo />);
        } else if (PageView.For === 'PAGE_NOT_FOUND') {
            return (<PageNotFound />);
        } else if (PageView.For === 'SOMETHING_WENT_WRONG') {
            return (<SomethingWentWrong />);
        } else if (PageView.For === 'SHOW BACK PAGE') {
            return (<CompanyTermsAndConditions />);
        }
        else if (PageView.For === 'SHOW ADDENDUM') {
            return (<ShowAddendum />);
        }
        else if (PageView.For === 'SHOW ESTIMATE ADDENDUM') {
            return (<ShowEstimateAddendum />);
        }
        else {
            return (<PageNotFound />);
        }
    }
    return (
        <>
            {getPage()}
            {/* Rendering google map as parent to stop re-rendering it on page changes*/}
            <div style={PageView.For == 'CLIENT_PORTAL' ? {display: 'block'}: {display:'none'}}>
                <GoogleMap />
            </div>

        </>
    )
}

const FetchDigitalInvoiceRecord = (PageView,RecordsController,For,InvoiceType,Url)=>{

    // If Invoice Type is Invoice-1/Invoice-2 then Fetch records for Invoice-1/Invoice-2 and render Invoice-1/Invoice-2 on the Screen.
    axios({method: 'post', url: Url, params: {estimate_key: Elink}})
        .then(async (response) => {
            if (For === 'SetIV1_PageDetails') {
                await RecordsController.SetIV1_PageDetails(response.data)
            } else if (For === 'SetIV2_PageDetails') {
                await RecordsController.SetIV2_PageDetails(response.data)
            }
            PageView.Set(InvoiceType)
            // After render the Invoice-1/Invoice-2, In backend fetch the records for Client-Portal to render it in less time.
            axios({
                method: 'post',
                url: FetchEstimateRecordsUrl,
                params: {estimate_key: Elink}
            }).then((response) => {
                RecordsController.SetCP_PageDetails(response.data)
            })
        }).catch(() => {
        PageView.Set('SOMETHING_WENT_WRONG')
    })
}

export default MainPage;